<div class="modal-overlay" *ngIf="show">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faHistory"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'MODELS.HISTORY.TITLE' | translate }}</h3>
          <p>{{ model?.name }}</p>
        </div>
      </div>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="loading" class="loading-state">
        <div class="spinner"></div>
      </div>

      <div *ngIf="!loading && history.length === 0" class="empty-state">
        <div class="empty-icon">
          <fa-icon [icon]="faInfoCircle"></fa-icon>
        </div>
        <p>{{ 'MODELS.HISTORY.EMPTY' | translate }}</p>
      </div>

      <div *ngIf="!loading && history.length > 0" class="history-list">
        <div class="history-card" *ngFor="let entry of history" [class.expanded]="selectedDeployment?.id === entry.id"
          [class.active-card]="entry.is_active">
          <div class="card-main" (click)="toggleDetails(entry)">
            <div class="card-info">
              <div class="active-badge" *ngIf="entry.is_active">
                <fa-icon [icon]="faCheckCircle"></fa-icon>
                <span>{{ 'MODELS.HISTORY.ACTIVE_VERSION' | translate }}</span>
              </div>
              <div class="timestamp">
                <div class="date-badge">
                  <fa-icon [icon]="faCalendarAlt"></fa-icon>
                  <span>{{ formatDate(entry.created_at) }}</span>
                </div>
                <div class="time-badge">
                  <fa-icon [icon]="faClock"></fa-icon>
                  <span>{{ formatTime(entry.created_at) }}</span>
                </div>
              </div>
              <div class="user-badge">
                <fa-icon [icon]="faUser"></fa-icon>
                <span>{{ entry.user }}</span>
              </div>
            </div>

            <div class="card-actions">
              <button class="action-btn revert" (click)="$event.stopPropagation(); onRevert(entry)"
                [title]="'BUTTON.REVERT' | translate" [disabled]="entry.is_active" [class.disabled]="entry.is_active">
                <fa-icon [icon]="faUndo"></fa-icon>
              </button>
              <div class="expand-icon">
                <fa-icon [icon]="selectedDeployment?.id === entry.id ? faChevronUp : faChevronDown"></fa-icon>
              </div>
            </div>
          </div>

          <div class="card-details" *ngIf="selectedDeployment?.id === entry.id">
            <div class="details-section">
              <div class="section-header">
                <h4>{{ 'MODELS.HISTORY.SNAPSHOT' | translate }}</h4>
                <button class="download-btn" (click)="onDownloadSnapshot(entry)"
                  [title]="'BUTTON.DOWNLOAD_JSON' | translate">
                  <fa-icon [icon]="faDownload"></fa-icon>
                  <span>JSON</span>
                </button>
              </div>
              <div class="snapshot-grid">
                <div class="snapshot-item" *ngFor="let item of (entry.snapshot | keyvalue)">
                  <div class="key-row">
                    <span class="key">{{ item.key }}</span>
                  </div>
                  <span class="value">{{ formatValue(item.value) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer">
      <app-button [text]="'BUTTON.CLOSE' | translate" variant="secondary" (clicked)="onClose()">
      </app-button>
    </div>
  </div>
</div>

<app-modal-confirm [show]="showRevertConfirm" [title]="'MODELS.HISTORY.REVERT_CONFIRM_TITLE'"
  [message]="'MODELS.HISTORY.REVERT_CONFIRM_MSG'" [confirmLabel]="'BUTTON.REVERT'" [icon]="faUndo" variant="primary"
  (close)="showRevertConfirm = false" (confirm)="onConfirmRevert()">
</app-modal-confirm>